export enum UmpireFilterOption {
  RECENT = 'finished',
  UPCOMING = 'upcoming',
  ALL = 'all',
}
